import React from 'react';
import { useAppContext } from '../../Services/AppContext';
import CaseChatEntryFileProcessing from './CaseChatEntryFileProcessing';
import CaseChatEntryFileInfected from './CaseChatEntryFileInfected';
import FirstUpper from '../FirstUpper';
import CaseChatEntryFileToDocumentationModal from './CaseChatEntryFileToDocumentationModal';
import { useState } from 'react';
import MediaViewerModal from '../MediaViewer/MediaViewerModal';
import {
	getCaseEntryFileThumbUrl,
	prepareCaseEntryFileForMediaViewer,
} from '../../Modules/CaseChat/Services/CaseChatEntryService.service';
import { CaseEntry } from '../../graphql/graphql';

interface CaseChatEntryFileProps {
	entry: CaseEntry;
	beforeChange: () => void;
	afterChange: () => void;
}

export default function CaseChatEntryFile(props: CaseChatEntryFileProps) {
	const { translation, socketUrl } = useAppContext();
	const { entry, beforeChange, afterChange } = props;
	const [moveToDocumentationModalOpened, setMoveToDocumentationModalOpened] =
		useState(false);
	const [mediaViewerOpened, setMediaViewerOpened] = useState(false);

	const handleShowMediaViewer = () => {
		setMediaViewerOpened(true);
	};

	const handleModalClose = () => {
		setMoveToDocumentationModalOpened(false);
		afterChange();
	};

	const handleMoveToDocumentation = () => {
		setMoveToDocumentationModalOpened(true);
	};

	if (entry.avResult === 'unprocessed' || !entry.avResult) {
		return <CaseChatEntryFileProcessing />;
	}

	if (entry.avResult === 'infected' || entry.avResult === 'other') {
		return <CaseChatEntryFileInfected />;
	}

	if (entry.thumb) {
		const thumbUrl = getCaseEntryFileThumbUrl(entry, socketUrl);
		return (
			<div className='chat-message__message'>
				<div className='message-photo'>
					<a onClick={handleShowMediaViewer} style={{ cursor: 'pointer' }}>
						<div
							className='message-photo__image'
							style={{ backgroundImage: 'url(' + thumbUrl + ')' }}
						/>
					</a>
				</div>
				{!entry.inDocumentation && (
					<a
						className='btn-link blue'
						style={{ marginBottom: 0 }}
						onClick={handleMoveToDocumentation}>
						<FirstUpper>
							{translation['base.saveToHealthDocumentation']}
						</FirstUpper>
					</a>
				)}
				<CaseChatEntryFileToDocumentationModal
					opened={moveToDocumentationModalOpened}
					entry={entry}
					onClose={handleModalClose}
				/>
				<MediaViewerModal
					opened={mediaViewerOpened}
					onClose={() => setMediaViewerOpened(false)}
					file={prepareCaseEntryFileForMediaViewer(entry, socketUrl)}
				/>
			</div>
		);
	}

	return (
		<div className='chat-message__message'>
			<div>
				<a onClick={handleShowMediaViewer} style={{ cursor: 'pointer' }}>
					<i className='fa fa-file'></i> {entry.message}
				</a>
			</div>
			{!entry.inDocumentation && (
				<a
					className='btn-link blue'
					style={{ marginBottom: 0 }}
					onClick={handleMoveToDocumentation}>
					<FirstUpper>
						{translation['base.saveToHealthDocumentation']}
					</FirstUpper>
				</a>
			)}
			<CaseChatEntryFileToDocumentationModal
				opened={moveToDocumentationModalOpened}
				entry={entry}
				onClose={handleModalClose}
			/>
			<MediaViewerModal
				opened={mediaViewerOpened}
				onClose={() => setMediaViewerOpened(false)}
				file={prepareCaseEntryFileForMediaViewer(entry, socketUrl)}
			/>
		</div>
	);
}
